import { render, staticRenderFns } from "./scatter-plot-apex.vue?vue&type=template&id=ecb9563e&scoped=true&"
import script from "./scatter-plot-apex.vue?vue&type=script&lang=js&"
export * from "./scatter-plot-apex.vue?vue&type=script&lang=js&"
import style0 from "./scatter-plot-apex.vue?vue&type=style&index=0&id=ecb9563e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb9563e",
  null
  
)

component.options.__file = "scatter-plot-apex.vue"
export default component.exports